import styled from '@emotion/styled';

// export const Container = styled.div`
//   height: 100vh;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   /* font-size: 40px; */
//   color: #010101;
//   display: grid;
//   grid-template-columns: 1fr;
//   grid-gap: 16px;
//   padding-bottom: 24px;
//   height: 100%;
// `;

export const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
`;
